import React from "react";

export default function MyAccount() {
  return <div>Forgot Pass</div>;
}
